Drupal.behaviors.navigationTweaks = {
  attach() {
    // eslint-disable-next-line func-names
    window.onload = function() {
      /* eslint-disable */
      document
        .querySelectorAll('.menu__primary--item--expanded.menu__level-0')
        .forEach(function(element) {
          /* eslint-enable */
          function mOver() {
            element.getElementsByClassName('layout-megamenu-wrapper')[0].classList.add('show');
            if(screen.width > 1280){
              element.getElementsByClassName('layout-megamenu-content')[0].classList.remove('hidden');
            } 
          }

          function mOut() {
            element.getElementsByClassName('layout-megamenu-wrapper')[0].classList.remove('show');
          }

          element.addEventListener('mouseover', mOver, false);
          element.addEventListener('mouseout', mOut, false);
        });

        document.querySelectorAll(".menu__level-0.menu__primary--item--expanded > a")
        .forEach(function(element) {
          element.classList.add('arrow_right');
          function menuClick(event) {
            event.preventDefault();
            this.nextElementSibling.classList.toggle('hidden');
            this.classList.toggle('arrow_up');
          }
          if(screen.width < 1280){
            element.nextElementSibling.classList.add('hidden');
            element.addEventListener("click", menuClick, false);
          }
  
        });
        
        document.querySelectorAll(".layout-megamenu-cols-wrapper .block-navigation h3")
        .forEach(function(element) {
          function submenuClick(event) {
            event.preventDefault();
            element.nextElementSibling.classList.toggle('hidden');
            this.classList.toggle('arrow_up');
          }
          if(screen.width < 1280){
            element.classList.add('arrow_right');
            element.nextElementSibling.classList.add('hidden');
            element.addEventListener("click", submenuClick, false);
          }
  
        });
    };   


    /*--------sidebar menu accessibily js----------*/
    setTimeout(function(){
      jQuery('.menu-wrapper-level-1 > li > div > .dropdown.open').find('.menu-accessibilty-txt').text('click to close submenu');
      jQuery('.menu-wrapper-level-0 > li > div > .dropdown.open').find('.menu-accessibilty-txt').text('click to close sidebar navigation');
    }, 100);
      
      jQuery('.menu-wrapper-level-1 > li > div > .dropdown').on('click',function(){
          
          if(jQuery(this).hasClass('open')){
            jQuery(this).find('.menu-accessibilty-txt').text('click to open submenu');
          }
          else {
            jQuery(this).find('.menu-accessibilty-txt').text('click to close submenu');
          }
      });

      jQuery('.menu-wrapper-level-0 > li > div > .dropdown').on('click',function(){
          
        if(jQuery(this).hasClass('open')){
          jQuery(this).find('.menu-accessibilty-txt').text('click to open sidebar navigation');
        }
        else {
          jQuery(this).find('.menu-accessibilty-txt').text('click to close sidebar navigation');
        }
    });

     /*--------sidebar menu accessibily js end----------*/

    /*--------search open close js----------*/
    const $searchpopup = jQuery('#searchpopup');
    const $searchicon = jQuery('#opensearch');

    jQuery('html,body').on('click touchstart',function(e){
      e.stopPropagation();
      if(!jQuery(e.target).is($searchpopup) && !jQuery(e.target).is(jQuery('#searchpopup *'))  && !jQuery(e.target).closest($searchicon).length ){
        $searchpopup.removeClass('block');
        $searchpopup.addClass('hidden');
      }
    });

    $searchicon.on('click', (e) => {
      e.preventDefault();
      setTimeout(function(){
        if($searchpopup.is(':visible')){
          $searchpopup.removeClass('block');
          $searchpopup.addClass('hidden');
        }
        else {
          $searchpopup.addClass('block');
          $searchpopup.removeClass('hidden');
        }
      },500);
    });
    /*--------search open close js end----------*/
  },
};
